/*
 * @Author: w9013327 v-maijiahua@oppo.com
 * @Date: 2022-11-01 18:26:49
 * @LastEditors:  jordan.lu@oppo.com
 * @LastEditTime: 2024-05-10 17:52:09
 * @FilePath: \community-frontend\src\service\http.js
 * @Description: 
 */
// 封装请求
import axios from 'axios'
// import QS from 'qs'
// import { ElMessage } from 'element-plus'
import { useUserStore } from '@/stores/user'

import jsBridge from '@/jsBridgeApi'

import { toast } from '@/utils/ui'
import { v4 as uuidv4 } from 'uuid';

// 多国默认语言
if (!localStorage.communityLanguage) {
  const defaultLanguage = import.meta.env.VITE_COUNTRY === 'CHINA' ? {
    name: '简体中文',
    value: 'zh-CN'
  } : {
    name: 'English',
    value: 'en-GB'
  }
  localStorage.setItem('communityLanguage', JSON.stringify(defaultLanguage))
}

const isMyOppo = /usercenter/i.test(navigator.userAgent.toLowerCase())

const isOneplus = navigator.userAgent.toLowerCase().includes('oneplus') && (window.HeytapNativeApi && !!window.HeytapNativeApi.invoke)

const isOppoApp = navigator.userAgent.toLowerCase().includes('oppocommunity') && (window.HeytapNativeApi && !!window.HeytapNativeApi.invoke)

const isOppoStore = location.href.includes('storeapp') || (window.OppoStoreClientStoreJS && window.OppoStoreClientBaseJS && window.OppoStoreClientUserJS)

const isMarket = navigator.userAgent.toLowerCase().includes('appmarket') || location.href.includes('fromAppRate')


let appPackageType = '' // app标识
// let model = ''	// 手机名
let source = window.outerWidth < 1024 ? 'MOBILE' : 'PC' // 来源

// 添加app标识
if (isOppoStore) {
	source = 'store'
}
if (isMyOppo) {
	source = 'myoppo'
}
if (isMarket) {
  source = 'appmarket'
}
if (isOppoApp || isOneplus) {
  source = 'APP'
}


// 请求

axios.defaults.timeout = 60000;
// 开发环境代理
axios.defaults.baseURL = import.meta.env.VITE_ENV === 'PRD' ? '/ajax' : '/proxy/ajax'
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'
// axios.defaults.headers.post['Content-Type'] = 'application/json;charset=utf-8';
axios.defaults.headers['tz'] = Intl.DateTimeFormat().resolvedOptions().timeZone
axios.defaults.headers['appPackageType'] = appPackageType
axios.defaults.headers['source'] = source
axios.defaults.headers['appCode'] = 'community'



/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params = {}) {

	params.t = new Date().getTime()

	return new Promise((resolve, reject) => {
	axios.get(url, {
			params
		}).then(res => {
      if (!res || res.status > 304) {
        resolve({
          code: 500,
          msg: res?.error?.message || 'Request Error',
        })
        return
      }
			resolve(res.data);
		}).catch(err => {
			reject(err.data)
		})
	});
}

/** 
 * post方法，对应post请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 */
export function post(url, data) {
	return new Promise((resolve, reject) => {
		axios.post(url, data)
			.then(res => {
        if (!res || res.status > 304) {
          resolve({
            code: 500,
            msg: res?.error?.message || 'Request Error',
          })
          return
        }
				resolve(res.data);
			})
			.catch(err => {
				reject(err.data)
			})
	});
}

// 请求拦截
axios.interceptors.request.use(
	async (config) => {
		const { data, params } = config
    if (data) {
      if (data.contentType) {
        config.headers['Content-Type'] = data.contentType;
        delete data.contentType
      }
      // 需要登录态
      if (data.needAuth) {
        config.headers['Need-Auth'] = true;
        delete data.needAuth
      }
      // 错误提示
      if (data?.needToastErr || params?.needToastErr) {
        config.headers['Err-Tst'] = true;
        delete data.needToastErr
      }
      // 是否接入风控
      if (data.bspSwitch) {
        const bspKey = uuidv4()
        await window.bspWwas.init()
        config.headers['bspKey'] = bspKey
        const signHeaders = window.bspWwas
          .random(
            'POST', 
            { bspKey }, 
            `${window.origin}${config.baseURL}${config.url}`
          )
        Object.keys(signHeaders).forEach(i => {
          config.headers[i] = signHeaders[i]
        })
        delete data.bspSwitch
      }
      if (data?.appCode) {
        config.headers['appCode'] = data.appCode;
        delete data.appCode
      }
    }
    if (params) {
      // 是否接入风控
      if (params.bspSwitch) {
        await window.bspWwas.init()
        const signHeaders = window.bspWwas
          .random(
            'GET', 
            '', 
            `${window.origin}${config.baseURL}${config.url}`
          )
        Object.keys(signHeaders).forEach(i => {
          config.headers[i] = signHeaders[i]
        })
        delete params.bspSwitch
      }
      if (params.contentType) {
        config.headers['Content-Type'] = params.contentType;
        delete params.contentType
      }
      // 需要登录态
      if (params.needAuth) {
        config.headers['Need-Auth'] = true;
        delete params.needAuth
      }
      // 错误提示
      if (params?.needToastErr || params?.needToastErr) {
        config.headers['Err-Tst'] = true;
        delete params.needToastErr
      }
      if (params?.appCode) {
        config.headers['appCode'] = params.appCode;
        delete params.appCode
      }
    }
    config.headers['lang'] = JSON.parse(localStorage.getItem('communityLanguage')).value
    // 1+社区app调用需同步app接口/头部参数
    if (isOneplus || isOppoApp) {
      const deviceInfo = await jsBridge.getDeviceInfo()
      if (!deviceInfo.code) {
        const { ver, lang, model, osVer, romVer, scrSz, tz, ua, nt, versionCode } = deviceInfo.data || {}
        const timestamp = new Date().getTime()
        config.data = config.data || {}
        config.params = config.params || {}
        if (config.method.toLowerCase() === 'get') {
          Object.assign(config.params, {
            ver,
            timestamp
          }) 
        }
        if (config.method.toLowerCase() === 'post') {
          Object.assign(config.data, {
            ver,
            timestamp
          }) 
        }
        Object.assign(config.headers, {
          lang, model, osVer, romVer, scrSz, tz, ua, nt, versionCode
        })
      }
    }
    if (isMyOppo && window.location.href.indexOf('abroadList') === -1) {
      try {
        const { data } = await jsBridge.getClientContext()
        config.headers["model"] = data.model
        // config.headers['lang'] = context['languageTag']
        const deviceName = await jsBridge.getDeviceName()
        if (deviceName) {
          config.headers["deviceName"] = deviceName
        }
      } catch (e) {
      }
    }
		
		// app 设置手机内销型号
		
		if (config.method === 'get') {
			config.params.t = new Date().getTime();
		}
    //uuid
    var uniqueId = localStorage.getItem('uniqueId')
    if(uniqueId !== null) {
      config.headers['ua'] = uniqueId
    }
		return config;
	},
	(error) => {
		return {
      status: 500,
      data: {
        code: 500
      },
      error,
    };
	})

axios.interceptors.response.use(
	function (response) {
    const { config: { headers }, data } = response

    // 需要登录态
    if (data && Number(data.code) === 401 && headers['Need-Auth']) {
      const userStore = useUserStore()
      userStore.onLogin()
      return
    }
    if (data.code !== 200 && headers['Err-Tst']) {
      toast({
        message: data.msg
      })
    }
		return response;
	},
	function (error) {
		return {
      status: 500,
      data: {
        code: 500
      },
      error,
    };
	}
);
export default axios